import { useEffect, useState } from "react";
import imageUrlBuilder from "@sanity/image-url";
import sanityClient from "../client.js";

const ImageSlide = (props) => {
  const { slide, index, currentIndex, isMobile } = props;

  const [imageSrc, setImageSrc] = useState(null)

  const builder = imageUrlBuilder(sanityClient);

  function urlFor(source) {
    return builder.image(source);
  }

  useEffect(()=>{

    if(isMobile && slide.coverImageMobile !== ''){
        setImageSrc(`${urlFor(slide.coverImageMobile)}`)
    } else {
        setImageSrc(`${urlFor(slide.coverImage)}`);
    }

  },[isMobile])

  const [defaultBackground, setDefaultBackground] = useState("#FFF");
  const [isCurrentSlide, setIsCurrentSlide] = useState(false);

  useEffect(() => {
    if (slide.color === "white") {
      setDefaultBackground("#000");
    } else if (slide.color === "black") {
      setDefaultBackground("#FFF");
    } else {
      setDefaultBackground("#FFF");
    }
  }, []);

  useEffect(() => {
    if (index === currentIndex) {
      setIsCurrentSlide(true);
    } else {
      setIsCurrentSlide(false);
    }
  }, [index, currentIndex]);

  return (
    <div
      className={`carousel__image-slide 
        ${isCurrentSlide ? "active" : ""}
        ${slide.layout}
        `}
      style={{
        backgroundColor:
          slide.background !== "" ? `${slide.background}` : defaultBackground,
        backgroundImage: `url(${imageSrc})`,
      }}
    />
  );
};

export default ImageSlide;
